//New Add Payment

import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Input,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import "../index.css";
import http from "../services/httpService";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import handleValidation from "../utils/handleValidations";
import {
  getDate,
  getToday,
  investmentDetailsPath,
  investmentPath,
  prospectDetailsPath,
  prospectPath,
} from "../utils/varialbles";
import RefreshIcon from "@mui/icons-material/Refresh";
import InputAdornment from "@mui/material/InputAdornment";
import { red } from "@material-ui/core/colors";
//import MenuItem from '@material-ui/core/MenuItem';
//import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    // paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 235,
  },
  checked: {},
  payment: {
    marginBottom: theme.spacing(1),
    borderTop: "1px solid",
    paddingBlock: theme.spacing(3),
  },
}));

function AddPayment() {
  let history = useHistory();
  //const [formObject, setFromObject] = useState({});
  //(formObject);
  //const [lookupFile, setLookupFile] = useState(null);
  //(lookupFile);

  const [showfields, setShowfields] = useState(false);
  const [showsSatesList, setShowStateList] = useState([]);
  const [order, setorder] = useState(null);
  const [pay, setpay] = useState(null);
  const [idlink, setidlink] = useState(null);
  const [standard, setStandard] = useState(null);
  const [custom, setCustom] = useState(null);
  const [disCount, setDisCount] = useState("");
  const [subamount, setSubamount] = useState(0);
  const [profile, setProfile] = useState({});
  const [service, setService] = useState([]);
  const [field, setField] = useState({});
  const [copySuccess, setCopySuccess] = useState("");
  const [fname, setFname] = useState("No File Choosen");
  const [quantityDisable, setQuantityDisable] = useState(false);
  const [FieldDisable, setFieldDisable] = useState(true); //Discount
  const [refreshDisable, setrefreshDisable] = useState(false); //Remark, Paymenttype, stype

  const [orderDisable, setOrderDisable] = useState(true);
  const [paymentDisable, setPaymentDisable] = useState(true);
  const [dateDisable, setDateDisable] = useState(false);
  const itemsRenderField = ["custom"];
  const classes = useStyles();
  const location = useLocation();
  const myparam = location.state;

  // const fileInputRef = useRef(null)

  const custid = location.state.cust__id || location.state.customer_id;
  const [form, setForm] = useState({
    cust_id: custid,
    firstname: "",
    lastname: "",
    state: "",
    service_type: "",
    quantity: "",
    discount: "0",
    remark: "",
    sub_amt: "",
    payment_type: "",
    mobile: "",
    // date: "",
    order_id: "",
    payment_id: "",
    sessiontime: "",
    // proof: "",
  });

  const {
    cust_id,
    firstname,
    lastname,
    state,
    service_type,
    quantity,
    discount,
    remark,
    sub_amt,
    mobile,
    payment_type,
    // date,
    order_id,
    payment_id,
    sessiontime,
    // proof,
  } = form;

  // (form);

  // send this obj on generate
  const obj1 = {
    cust_id,
    firstname,
    lastname,
    state,
    discount,
    payment_type,
    service_type,
    remark,
    mobile,
    sub_amt,
    sessiontime,
  };
  const obj2 = {
    cust_id,
    firstname,
    lastname,
    state,
    discount,
    payment_type,
    service_type,
    remark,
    sub_amt,
    sessiontime,
  };

  // const obj3 = {
  //   cust_id,
  //   firstname,
  //   lastname,
  //   state,
  //   link_id: idlink,
  //   proof,
  // };

  const gotoProspectDetails = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };

  useEffect(() => {
    // let cid = custid;

    var custid = "";

    if (location.state.cust__id || location.state.customer_id) {
      custid = location.state.cust__id || location.state.customer_id;
      // .get(`/payment_options?cust_id=${custid}`)
      http
        .get(`/subscription_options?cust_id=${custid}`)
        .then((res) => {
          const cust = res.data.data;
          setProfile(res.data.data);
          // setService(res.data.serv);
          setService(res.data.data);
          setForm({
            ...form,
            firstname: cust.custfirstname,
            lastname: cust.custlastname,
            state: cust.custstate,
          });
          // (res.data.data.custstate);
        })
        .catch((err) => {});

      http
        .get("/statesList")
        .then((res) => {
          //(res);
          //(res.data.Data);
          setShowStateList(res.data.Data);
        })
        .catch((err) => {});
    }
  }, []);

  // (profile.custfirstname);

  useEffect(() => {
    setForm({ ...form, sub_amt: subamount });
    // return () => {
    //   second
    // }
  }, [subamount]);

  useEffect(() => {
    setForm({ ...form, payment_id: pay, order_id: order });
    // return () => {
    //   second
    // }
  }, [pay, order]);

  const handleChange2 = (e) => {
    // let name = e.target.name;
    let value = e.target.value;
    setForm((prevForm) => ({
      ...prevForm,
      [e.target.name]: e.target.value,
    }));
    const custid = location.state.cust__id || location.state.customer_id;
    // setForm({ ...form, amount: subamount });
    // console.log(value, "value");
    http
      .get(
        `/applyDiscount?service_type=${encodeURIComponent(
          service_type
        )}&discount=${value}&cust_id=${custid}`
      )
      .then((res) => {
        setSubamount(res.data.data);
      })
      .catch((err) => {});

    // setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBlur = (e) => {
    // let name = e.target.name;
    const custid = location.state.cust__id || location.state.customer_id;
    let value = e.target.value;
    if (!value) {
      http
        .get(
          `/applyDiscount?service_type=${encodeURIComponent(
            service_type
          )}&discount=${0}&cust_id=${custid}`
        )
        .then((res) => {
          if (res.data.data === "Exception") {
            toast.error(res.data.error);
            setForm({
              ...form,
              discount: "0",
            });
          } else {
            setSubamount(res.data.data);
            setForm({
              ...form,
              discount: "0",
            });
          }
        })
        .catch((err) => {});
    } else {
      http
        .get(
          `/applyDiscount?service_type=${encodeURIComponent(
            service_type
          )}&discount=${value}&cust_id=${custid}`
        )
        .then((res) => {
          if (res.data.data === "Exception") {
            toast.error(res.data.error);
            setForm({
              ...form,
              discount: "0",
            });
            // setSubamount(0);
          } else {
            setSubamount(res.data.data);
            toast.success("Discount Applied");
          }
        })
        .catch((err) => {});
    }
  };

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    setForm((prevForm) => ({
      ...prevForm,
      [event.target.name]: event.target.value,
    }));

    if (name === "service_type") {
      http
        .get(`/discount?service_type=${encodeURIComponent(value)}`)
        .then((res) => {
          setDisCount(res.data.data);
        })
        .catch((err) => {});

      http
        .get(
          `/applyDiscount?service_type=${encodeURIComponent(
            value
          )}&discount=${0}&cust_id=${custid}`
        )
        .then((res) => {
          setSubamount(res.data.data);
        })
        .catch((err) => {});
      setFieldDisable(false);
    }

    if (value === "U") {
      if (
        localStorage.getItem("empRole") !== "CRT Manager" &&
        localStorage.getItem("empRole") !== "CRT Executive" &&
        localStorage.getItem("empRole") !== "CTO" &&
        localStorage.getItem("empRole") !== "Sales Manager"
      ) {
        setFieldDisable(true);
      }
    }
  };

  const handleChangeAmount = (e) => {
    setForm((prevForm) => ({
      ...prevForm,
      [e.target.name]: e.target.value,
    }));
    console.log(form);
    const custid = location.state.cust__id || location.state.customer_id;
    let value = e.target.value;
    if (service_type !== "" || service_type !== null) {
      http
        .get(
          `/applyDiscount?service_type=${encodeURIComponent(
            service_type
          )}&discount=${0}&cust_id=${custid}`
        )
        .then((res) => {
          setSubamount(res.data.data);
        })
        .catch((err) => {});
      setFieldDisable(false);
    }
    if (value === "U") {
      if (
        localStorage.getItem("empRole") !== "CRT Manager" &&
        localStorage.getItem("empRole") !== "CRT Executive" &&
        localStorage.getItem("empRole") !== "CTO" &&
        localStorage.getItem("empRole") !== "Sales Manager"
      ) {
        setFieldDisable(true);
      }
    }
    // setForm({ ...form, amount: subamount });
    // setForm({ ...form, [e.target.name]: e.target.value, quantity: "1" });
    setForm((prevForm) => ({
      ...prevForm,
      [e.target.name]: e.target.value,
      quantity: "1",
    }));

    setQuantityDisable(true);
  };

  // console.log(form);
  const date = new Date();

  // const min = (
  //   date.getFullYear() +
  //   "-" +
  //   (date.getMonth() + 1) +
  //   "-" +
  //   date.getDate()
  // )
  //   .toString()
  //   .slice(0, 10);

  const max2 = (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 2) +
    "-" +
    date.getDate()
  )
    .toString()
    .slice(0, 10);

  // Calculate min value (current date)
  const min =
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    date.getDate().toString().padStart(2, "0");

  // Calculate max value (next month)
  let maxYear = date.getFullYear();
  let maxMonth = date.getMonth() + 2;
  let maxDate = date.getDate();

  if (maxMonth > 12) {
    maxMonth = maxMonth - 12;
    maxYear = maxYear + 1;
  }

  const max =
    maxYear +
    "-" +
    maxMonth.toString().padStart(2, "0") +
    "-" +
    maxDate.toString().padStart(2, "0");

  // const newDate = date.getDate().toString().padStart(2, "0");
  // const newmonth = (date.getMonth() + 1).toString().padStart(2, "0");
  // const newyear = date.getFullYear();
  // const newhours=date.getHours() ;
  // const newmins = date.getMinutes();
  // console.log(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()); //to find n number days in a month
  // console.log(date.getDate() + 8);

  let endmonth = date.getMonth() + 1;
  // console.log(endmonth + 1);
  if (endmonth > 12) {
    endmonth = endmonth - 12 + 1;
    // maxYear = maxYear + 1;
  }

  let endDate = date.getDate() + 1;
  if (field["sessiontime"] === "1week") {
    endDate = date.getDate() + 1;
  } else if (field["sessiontime"] === "1day") {
    endDate = date.getDate() + 7;
  }

  // console.log(field["sessiontime"]);

  if (
    parseInt(endDate) >
    parseInt(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate())
  ) {
    endDate = (
      parseInt(endDate) -
      parseInt(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate())
    )
      .toString()
      .padStart(2, "0");
    endmonth = date.getMonth() + 2;
  }

  // console.log(endDate);

  const handleChange1 = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setField({ ...field, [name]: value });
    if (name === "sessiontime") {
      if (value === "1day") {
        setForm({
          ...form,
          sessiontime:
            maxYear +
            "-" +
            endmonth.toString().padStart(2, "0") +
            "-" +
            endDate.toString().padStart(2, "0") +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes(),
        });
      }
      if (value === "1week") {
        setForm({
          ...form,
          sessiontime:
            maxYear +
            "-" +
            endmonth.toString().padStart(2, "0") +
            "-" +
            endDate.toString().padStart(2, "0") +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes(),
        });
      }
      if (value === "1month") {
        setForm({
          ...form,
          sessiontime:
            maxYear +
            "-" +
            (endmonth + 1).toString().padStart(2, "0") +
            "-" +
            date.getDate().toString().padStart(2, "0") +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes(),
        });
      }
      if (value === "customday") {
        setForm({ ...form, sessiontime: value });
      }
    }
    // console.log(value);
    if (name === "payment_type") {
      setForm({
        ...form,
        payment_type: value,
      });
    }
  };

  const handleChange_sessiontime_date = (e) => {
    // console.log(e.target.value);
    setForm({
      ...form,
      sessiontime:
        e.target.value + " " + date.getHours() + ":" + date.getMinutes(),
    });
  };

  const [baseImage, setBaseImage] = useState("");

  const [image, setImage] = useState([]);

  let data = new FormData();
  // (image + " " + "this is image pathname");
  data.append("image", image);

  // (image);

  const handleFileChange = (event) => {
    setFname(event.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      setForm({ ...form, proof: reader.result });
    };
  };

  const handleRefresh = (e) => {
    // e.preventDefault();
    // setForm({
    //   // cust_id: "",
    //   // firstname: "",
    //   // lastname: "",
    //   // state: "",
    //   service_type: "",
    //   quantity: "",
    //   sub_amt: "",
    //   payment_type: "",
    //   mobile: "",

    //   // date: "",
    //   proof: "",
    //   payment_id: "",
    // });
    // setFname("No File Choosen");

    if (idlink === "" || idlink === null) {
      toast.error("Please Generate Link");
    } else {
      http
        .get(`/getOrderDetails?cust_id=${cust_id}&link_id=${idlink}`)
        .then((res) => {
          setorder(res.data.data.order_id);
          setpay(res.data.data.payment_id);

          if (res.data.statusCode === 0) {
            toast.success("Payment Captured");
            setFieldDisable(true);
            setrefreshDisable(true);
          } else toast.error(res.data.error);
        })
        .catch((err) => {
          // toast.error(err);
        });
    }
  };

  const handleStandardCopy = (e) => {
    // if (!e.target.value==)
    navigator.clipboard
      .writeText(standard)
      .then(() => toast.success("Link Copied"));
    // setCopySuccess("Copied!"));

    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    // e.target.focus();
  };
  const handleCustomCopy = (e) => {
    navigator.clipboard
      .writeText(custom)
      .then(() => toast.success("Link Copied"));
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    // e.target.focus();
    // setCopySuccess("Copied!");
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // console.log(obj2);

  const handleGenerate = () => {
    if (payment_type === "custom") {
      if (
        cust_id === "" ||
        (firstname === "") | (firstname === null) ||
        (lastname === "") | (lastname === null) ||
        (state === "") | (state === null) ||
        discount === "" ||
        payment_type === "" ||
        service_type === "" ||
        mobile === "" ||
        sub_amt === "" ||
        remark === "" ||
        sessiontime === ""
      ) {
        toast.error("Required fields not filled");
      } else {
        http
          .post("/generateLink", obj1)
          .then((res) => {
            if (res.data.statusCode === 1) {
              toast.error(res.data.error);
            }
            if (res.data.statusCode === 0) {
              toast.success("Custom Link Generated");
              setCustom(res.data.data);
              setidlink(res.data.link_id);
              setStandard(null);
            }
          })
          .catch((err) => {});
      }
    } else if (payment_type === "standard") {
      if (
        cust_id === "" ||
        (firstname === "") | (firstname === null) ||
        (lastname === "") | (lastname === null) ||
        (state === "") | (state === null) ||
        discount === "" ||
        payment_type === "" ||
        service_type === "" ||
        sub_amt === "" ||
        remark === "" ||
        sessiontime === ""
      ) {
        toast.error("Required fields not filled");
      } else {
        http
          .post("/generateLink", obj2)
          .then((res) => {
            if (res.data.statusCode === 1) {
              toast.error(res.data.error);
            }
            if (res.data.statusCode === 0) {
              toast.success("Standard Link Generated");
              setStandard(res.data.data);
              setidlink(res.data.link_id);
              setCustom(null);
            }
          })
          .catch((err) => {});
      }
    } else {
      toast.error("Required fields not filled");
    }
  };

  // const handleSubmit1 = () => {
  //   if ((pay === "" || pay === null) && (order === "" || order === null)) {
  //     toast.error("Payment not captured");
  //   } else if (
  //     (pay === "" || pay === null || pay === undefined) &&
  //     (order === "" || order === null || order === undefined)
  //   ) {
  //     toast.error("Order Id & Payment Id not recieved");
  //   } else {
  //     http
  //       .post("/addPayment", obj3)
  //       .then((res) => {
  //         if (res.data.statusCode === 1) {
  //           toast.error(res.data.error);
  //         }
  //         if (res.data.statusCode === 0) {
  //           toast.success(res.data.data);
  //           if (myparam.cust__id) {
  //             history.push({
  //               pathname: prospectPath,
  //               state: { tab: "Overview" },
  //             });
  //           } else if (myparam.customer_id) {
  //             history.push({
  //               pathname: investmentPath,
  //               state: { tab: "Overview" },
  //             });
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         (err);
  //       });
  //   }
  // };

  // (service_type);
  // (profile.custstate.length);
  // (form);
  // (obj3);
  // (cust_id);
  // (profile);

  return (
    <Grid container component="main" className={"pb30"}>
      <Grid item xs={12} sm={5} md={5}>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoProspectDetails}
        >
          Back
        </Button>
      </Grid>
      <Grid item xs={12} className="mt30">
        {/* sm={5} md={5} */}
        <div
          style={{
            display: "flex",
            marginTop: "2rem",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Typography color="textPrimary" variant="h5">
              Add Payment
            </Typography>
          </div>
          <div>
            <Button
              variant="contained"
              onClick={handleRefresh}
              startIcon={<RefreshIcon />}
              style={{
                marginRight: "20px",
                borderRadius: "unset",
                background: "#2835D5",
                color: "#fff",
              }}
              // onClick={() => }
            >
              Refresh
            </Button>
            {/* <Button
              variant="contained"
              onClick={handleSubmit1}
              style={{
                marginRight: "10px",
                minWidth: "110px",
                borderRadius: "unset",
                background: "#2835D5",
                color: "#fff",
              }}
            >
              Submit
            </Button> */}
          </div>
        </div>
      </Grid>
      <Grid container style={{ marginTop: 30 }}>
        <Grid container className={classes.paper}>
          <Grid item xs={12}>
            {/* <Grid container >
              <Grid
                item
                xs={12}
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleRefresh}
                  startIcon={<RefreshIcon />}
                  style={{
                    marginRight: "20px",
                    borderRadius: "unset",
                    background: "#2835D5",
                    color: "#fff",
                  }}
                  // onClick={() => }
                >
                  Refresh
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  style={{
                    marginRight: "10px",
                    minWidth: "110px",
                    borderRadius: "unset",
                    background: "#2835D5",
                    color: "#fff",
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid> */}

            <Grid item lg={6} md={6} sm={6} xs={12}>
              {profile.custfirstname === null ? (
                <>
                  <Grid
                    item
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ marginBottom: "15px" }}
                  >
                    <InputLabel style={{ marginBottom: "15px" }}>
                      First Name <span style={{ color: "red" }}>&#42;</span>
                    </InputLabel>
                    <TextField
                      placeholder="Enter"
                      variant="outlined"
                      value={firstname}
                      name="firstname"
                      onChange={handleChange}
                      style={{ width: "300px" }}
                      disabled={refreshDisable ? "disabled" : ""}
                    />
                  </Grid>
                </>
              ) : (
                ""
              )}
              {profile.custlastname === null ? (
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginBottom: "15px" }}
                >
                  <InputLabel style={{ marginBottom: "15px" }}>
                    Last Name <span style={{ color: "red" }}>&#42;</span>
                  </InputLabel>
                  <TextField
                    placeholder="Enter"
                    variant="outlined"
                    value={lastname}
                    name="lastname"
                    onChange={handleChange}
                    style={{ width: "300px" }}
                    disabled={refreshDisable ? "disabled" : ""}
                  />
                </Grid>
              ) : (
                ""
              )}

              {profile.custstate === null ? (
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  id="firstselect"
                  style={{ marginBottom: "15px" }}
                >
                  <InputLabel style={{ marginBottom: "15px" }}>
                    State <span style={{ color: "red" }}>&#42;</span>
                  </InputLabel>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    {/* <InputLabel id="state">State</InputLabel> */}
                    <Select
                      //labelId="state"
                      id="service_type"
                      displayEmpty
                      value={state}
                      name="state"
                      onChange={handleChange}
                      style={{ width: "300px" }}
                      disabled={refreshDisable ? "disabled" : ""}
                    >
                      <MenuItem value="">Select</MenuItem>
                      {showsSatesList.map((item) => (
                        <MenuItem value={item}>{item}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                ""
              )}

              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={12}
                id="firstselect"
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Service Type <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <FormControl variant="outlined" className={classes.formControl}>
                  {/* <InputLabel id="state">State</InputLabel> */}
                  <Select
                    //labelId="state"
                    displayEmpty
                    id="service_type"
                    value={service_type}
                    name="service_type"
                    onChange={(e) => {
                      handleChange(e);
                      // handleChangeAmount(e);
                    }}
                    style={{ width: "300px" }}
                    disabled={refreshDisable ? "disabled" : ""}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {service.map((item) => (
                      <MenuItem value={item.value}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={12}
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Quantity <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <TextField
                  placeholder="Enter"
                  variant="outlined"
                  value={quantity}
                  name="quantity"
                  onChange={handleChange}
                  style={{ width: "300px" }}
                  type="number"
                  disabled={quantityDisable ? "disabled" : ""}
                />
              </Grid>

              {disCount === 0 || disCount.length <= 0 || disCount === "" ? (
                <Grid item xs={12} style={{ marginBottom: "15px" }}>
                  <InputLabel style={{ marginBottom: "15px" }}>
                    Discount <span style={{ color: "red" }}>&#42;</span>
                  </InputLabel>
                  <div style={{ display: "flex" }}>
                    <TextField
                      defaultValue="0"
                      placeholder="Enter"
                      variant="outlined"
                      value={discount}
                      name="discount"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{ width: "300px", marginRight: "25px" }}
                      type="text"
                      disabled={FieldDisable ? "disabled" : ""}
                      // InputProps={{
                      //   endAdornment: (
                      //     <InputAdornment>
                      //       <Button>Apply</Button>
                      //     </InputAdornment>
                      //   ),
                      // }}
                    />
                    <TextField
                      placeholder="Remark*"
                      variant="outlined"
                      value={remark}
                      name="remark"
                      onChange={handleChange}
                      style={{
                        width: "300px",
                      }}
                      type="text"
                      disabled={refreshDisable ? "disabled" : ""}
                    />
                  </div>
                </Grid>
              ) : (
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  id="firstselect"
                  style={{ marginBottom: "15px" }}
                >
                  <InputLabel style={{ marginBottom: "15px" }}>
                    Discount <span style={{ color: "red" }}>&#42;</span>
                  </InputLabel>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    {" "}
                    <div style={{ display: "flex" }}>
                      {/* <InputLabel id="state">State</InputLabel> */}
                      <Select
                        //labelId="state"
                        displayEmpty
                        id="service_type"
                        value={discount}
                        name="discount"
                        onChange={handleChange2}
                        style={{ width: "300px", marginRight: "15px" }}
                        disabled={FieldDisable ? "disabled" : ""}
                      >
                        <MenuItem value="">Select</MenuItem>
                        {disCount.length > 0 &&
                          disCount.map((item) => (
                            <MenuItem value={item.value}>{item.name}</MenuItem>
                          ))}
                      </Select>
                      <TextField
                        placeholder="Remark*"
                        variant="outlined"
                        value={remark}
                        name="remark"
                        onChange={handleChange}
                        style={{ width: "300px" }}
                        type="text"
                        disabled={refreshDisable ? "disabled" : ""}
                      />
                    </div>
                  </FormControl>
                </Grid>
              )}

              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={12}
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Subscription Amount{" "}
                  <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <TextField
                  variant="outlined"
                  value={subamount}
                  name="amount"
                  // onChange={handleChange}
                  style={{ width: "300px" }}
                  type="text"
                  disabled
                />
              </Grid>
              <Grid
                item
                xs={12}
                id="firstselect"
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Payment Type <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    {/* <InputLabel id="state">State</InputLabel> */}
                    <Select
                      //labelId="state"
                      // displayEmpty
                      defaultValue="Select"
                      id="service_type"
                      value={
                        field["payment_type"] ? field["payment_type"] : "Select"
                      }
                      name="payment_type"
                      onChange={handleChange1}
                      style={{
                        width: "300px",
                        marginRight: "25px",
                      }}
                      disabled={refreshDisable ? "disabled" : ""}
                    >
                      <MenuItem value="Select">Select</MenuItem>
                      <MenuItem value="standard">Standard</MenuItem>
                      <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                  </FormControl>

                  {field["payment_type"] === "custom" ? (
                    <TextField
                      placeholder="Enter Mobile No."
                      variant="outlined"
                      value={mobile}
                      name="mobile"
                      onChange={handleChange}
                      style={{ width: "300px" }}
                      type="number"
                    />
                  ) : null}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                id="firstselect"
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Session Timeout <span style={{ color: "red" }}>&#42;</span>
                </InputLabel>
                <div>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <Select
                      //labelId="state"
                      // displayEmpty
                      defaultValue="Select"
                      id="sessiontime"
                      value={field["sessiontime"] ? field["sessiontime"] : ""}
                      name="sessiontime"
                      onChange={handleChange1}
                      style={{
                        width: "300px",
                        marginRight: "25px",
                        height: "40px",
                      }}
                      disabled={refreshDisable ? "disabled" : ""}
                    >
                      <MenuItem value="Select">Select</MenuItem>
                      <MenuItem value="1day">1 day</MenuItem>
                      <MenuItem value="1week">1 week</MenuItem>
                      <MenuItem value="1month">1 month</MenuItem>
                      <MenuItem value="customday">Custom day</MenuItem>
                    </Select>
                  </FormControl>

                  {field["sessiontime"] === "customday" ? (
                    <input
                      type="date"
                      name="sessiontime_date"
                      min={min}
                      max={max}
                      onChange={handleChange_sessiontime_date}
                      style={{
                        width: 250,
                        height: 35,
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  ) : null}
                </div>
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={12}
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Order Id
                </InputLabel>
                <TextField
                  variant="outlined"
                  value={order}
                  name="payment_id"
                  onChange={handleChange}
                  style={{ width: "300px" }}
                  type="text"
                  disabled={orderDisable ? "disabled" : ""}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={12}
                style={{ marginBottom: "15px" }}
              >
                <InputLabel style={{ marginBottom: "15px" }}>
                  Payment Id
                </InputLabel>
                <TextField
                  variant="outlined"
                  value={payment_id}
                  name="payment_id"
                  onChange={handleChange}
                  style={{ width: "300px" }}
                  type="text"
                  disabled={paymentDisable ? "disabled" : ""}
                />
              </Grid>
              {/* <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={12}
                style={{ marginBottom: "15px" }}
              >
                <div>
                  <InputLabel style={{ marginBottom: "15px" }}>
                    Subscription Proof{" "}
                  </InputLabel>
                  <Button variant="contained" component="label">
                    Choose File
                    <input
                      hidden
                      id="file"
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e);
                      }}
                      // onChange={e => setImage(e.target.value)}
                      // style={{ display: "none" }}
                      multiple={false}
                      accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                    />
                  </Button>
                  <span style={{ marginLeft: "10px", fontWeight: "300" }}>
                    {fname}
                  </span>
                </div> */}
              {/* <img src={proof} /> */}
              {/* </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid container className={classes.submitButton}> */}
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        style={{
          textAlign: "right",
        }}
        className={classes.submitButton}
      >
        <Button
          variant="contained"
          color="primary"
          // onClick={handleGenerateLink}
          onClick={handleGenerate}
          style={{ borderRadius: "27px", background: "#2835D5", color: "#fff" }}
        >
          Generate Link
        </Button>
      </Grid>
      {/* </Grid> */}

      {/* HIDE THIS */}
      {standard === null ? (
        ""
      ) : (
        <Grid item xs={12} sm={12} md={12} className={classes.payment}>
          <InputLabel
            style={{ marginBottom: "15px", color: "#000", fontWeight: "700" }}
          >
            Standard Payment
            <span>{copySuccess}</span>
          </InputLabel>
          <div style={{ display: "flex" }}>
            <TextField
              variant="outlined"
              style={{ width: "90%", marginRight: "10px" }}
              type="text"
              onChange={handleChange}
              value={standard}
              disabled={paymentDisable ? "disabled" : ""}
            ></TextField>
            <Button
              variant="contained"
              style={{ borderRadius: "unset" }}
              onClick={handleStandardCopy}
            >
              Copy Link
            </Button>
          </div>
        </Grid>
      )}
      {custom === null ? (
        ""
      ) : (
        <Grid item xs={12} sm={12} md={12} className={classes.payment}>
          <InputLabel
            style={{ marginBlock: "15px", color: "#000", fontWeight: "700" }}
          >
            Custom Payment
          </InputLabel>
          <div style={{ display: "flex" }}>
            <TextField
              variant="outlined"
              style={{ width: "90%", marginRight: "10px" }}
              type="text"
              onChange={handleChange}
              value={custom}
              disabled={paymentDisable ? "disabled" : ""}
            ></TextField>
            <Button
              variant="contained"
              style={{
                borderRadius: "unset",
              }}
              onClick={handleCustomCopy}
            >
              Copy Link
            </Button>
          </div>
          {/* <p
          style={{
            fontSize: "18px",
            color: "#A1A1A1",
            opacity: "1",
          }}
        >
          You must enter the mobile number in order to generate custom link
        </p> */}
        </Grid>
      )}
    </Grid>
  );
}

export default AddPayment;

//Old Add Payment

// import { Button, FormControlLabel, Radio, RadioGroup, TextField, Select, MenuItem, FormControl } from '@material-ui/core';
// import Grid from '@material-ui/core/Grid';
// import InputLabel from '@material-ui/core/InputLabel';
// import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
// import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// import React, { useEffect, useRef, useState } from 'react';
// import toast from 'react-hot-toast';
// import { useHistory, useLocation } from "react-router-dom";
// import '../index.css';
// import http from "../services/httpService";
// import handleSubmitValidation from '../utils/handleSubmitValidation';
// import handleValidation from '../utils/handleValidations';
// import { getToday, investmentDetailsPath, investmentPath, prospectDetailsPath, prospectPath } from "../utils/varialbles";
// //import MenuItem from '@material-ui/core/MenuItem';
// //import FormControl from '@material-ui/core/FormControl';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         flexGrow: 1,
//     },
//     paper: {
//         paddingTop: theme.spacing(2),
//         textAlign: 'left',
//         color: theme.palette.text.primary,
//     },
//     submitButton: {
//         marginTop: theme.spacing(5),
//         marginBottom: theme.spacing(10),

//     },
//     gridDevider: {
//         marginTop: theme.spacing(6),
//         textAlign: 'left',
//         color: theme.palette.text.primary,
//     },
//     lableColor: {
//         color: "#393939"
//     },
//     select: {
//         height: 36,
//         minWidth: 235,

//     },
//     mobileCode: {
//         height: 36,
//     },
//     radio: {
//         '&$checked': {
//             color: '#57bf74'
//         }
//     }, reviewButton: {
//         borderRadius: "20px",
//         border: "1px solid #2835D5",
//         opacity: 1,
//         textAlign: "right"
//     },
//     formControl: {
//         margin: theme.spacing(1),
//         minWidth: 235,
//     },
//     checked: {}

// }));
// function AddPayment() {
//     let history = useHistory();
//     //const [formObject, setFromObject] = useState({});
//     //(formObject);
//     //const [lookupFile, setLookupFile] = useState(null);
//     //(lookupFile);
//     const [quantityDisable, setQuantityDisable] = useState(false);
//     const [dateDisable, setDateDisable] = useState(false);
//     const classes = useStyles();
//     const location = useLocation();
//     const myparam = location.state;
//     // const fileInputRef = useRef(null)
//     const [form, setForm] = useState({
//         cust_id: "",
//         firstname: "",
//         lastname: "",
//         state: "",
//         payment_id: "",
//         service_type: "",
//         quantity: "",
//         amount: "",
//         date: "",
//         proof: ""
//     });
//     const { cust_id, firstname, lastname, state, payment_id, service_type, quantity, amount, date, proof } = form

//     (form);

//     const columns = [
//         { "value": 'firstname', "imp": false, "label": 'First Name', minWidth: 150, "filedType": "text", isDisable: false },

//         { "value": 'lastname', "imp": false, "label": 'Last Name', minWidth: 150, "filedType": "text", isDisable: false },

//         { "value": 'state', "imp": false, "label": 'State', minWidth: 150, "filedType": "dropDown", isDisable: false },

//         { "value": 'service_type', "imp": true, "label": 'Subscription Type', minWidth: 170, "filedType": "radio", "options": [{ "label": "Savart X Plan", "value": "X" }, { "label": "Investment Requset", "value": "A" }, { "label": "Investment Review", "value": "R" }, { "label": "Early Renewal", "value": "L" }] },

//         { "value": 'quantity', "imp": true, "label": 'Quantity', minWidth: 150, "filedType": "number", isDisable: true },

//         { "value": 'amount', "imp": true, "label": 'Subscription Amount', minWidth: 150, "filedType": "number" },

//         { "value": 'date', "imp": true, "label": 'Subscription Date', minWidth: 150, "filedType": "date" },

//         // { "value": 'discount_type', "imp": true, "label": 'Payment Id', minWidth: 150, "filedType": "radio", "options": [{ "label": "Custom", "value": "Custom" }, { "label": "Student", "value": "Student" }, { "label": "Farmer", "value": "Farmer" }, { "label": "Milltary", "value": "Milltary" }, { "label": "Micro-Investor", "value": "Micro-Investor" }] },

//         { "value": 'payment_id', "imp": true, "label": 'Payment Id', minWidth: 150, "filedType": "text" },

//         { "value": 'proof', "imp": true, "label": 'Subscription proof', minWidth: 150, "filedType": "file" },

//         // { "value": 'reason', "imp": true, "label": 'Reason', minWidth: 150, "filedType": "textarea", multiline: true, rows: 5 },
//     ];
//     // const validations = {

//     //     "service_type": {
//     //         conditions: {
//     //             "required": true
//     //         }, "message": "This Field is required!", "valid": true, "changed": false
//     //     },
//     //     "quantity": {
//     //         conditions: {
//     //             "required": true,"minValue":1
//     //         }, "message": "This Field is required!", "valid": true, "changed": false
//     //     },
//     //     "reason": {
//     //         conditions: {
//     //             "required": true, "maxLength": 1000
//     //         }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
//     //     },
//     //     "date": {
//     //         conditions: {
//     //             "required": true,"minDate":getToday(),"pattren":/^\d{4}-\d{2}-\d{2}$/
//     //         }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
//     //     },
//     //     "amount": {
//     //         conditions: {
//     //             "required": true, "minValue": 10,
//     //         }, "message": "Maximum 20 character Allowed.!", "valid": true, "changed": false
//     //     },
//     //     "proof": {
//     //         conditions: {
//     //             "required": true
//     //         }, "message": "Proof is required!", "valid": true, "changed": false
//     //     },
//     //     "state": {
//     //         conditions: {
//     //             "required": true
//     //         }, "message": "state is required!", "valid": false, "changed": false
//     //     },
//     // }
//     //const [validationState, setValidationState] = useState(validations)
//     const gotoProspectDetails = () => {
//         if (myparam && myparam.cust__id) {
//             history.push({
//                 "pathname": prospectDetailsPath, state: myparam
//             });
//         } else if (myparam && myparam.customer_id) {
//             history.push({
//                 "pathname": investmentDetailsPath, state: myparam
//             });
//         }
//     }

//     // useEffect(() => {
//     //     if (myparam && (myparam.cust__id || myparam.customer_id)) {
//     //         //setFromObject(form)
//     //     }
//     //      else {
//     //         //gotoProspectDetails()
//     //     }

//     // }, [])

//     useEffect(() => {
//         if (location.state === undefined || location.state === null) {
//             gotoProspectDetails();
//             //(location);
//             //alert('undefined');

//         } else {
//             var custid = "";
//             if (location.state.cust__id) {
//                 custid = location.state.cust__id;
//                 http.get(`/customerPersonalProfileStatus?cust_id=${custid}`).then(res => {
//                     //(res);

//                     if (res.data.Data === "C") {
//                         setShowfields(false);
//                     }
//                     else if (res.data.Data === "P") {
//                         setShowfields(true);
//                     }
//                     //setShowStateList(res.data.Data);
//                 }).catch(err => {
//                     (err);
//                 });
//             }
//             else if (location.state.customer_id) {
//                 custid = location.state.customer_id;
//                 http.get(`/customerPersonalProfileStatus?cust_id=${custid}`).then(res => {
//                     //(res);

//                     if (res.data.Data === "C") {
//                         setShowfields(false);
//                     }
//                     else if (res.data.Data === "P") {
//                         setShowfields(true);
//                     }
//                     //setShowStateList(res.data.Data);
//                 }).catch(err => {
//                     (err);
//                 });
//             }

//             setForm({
//                 ...form,
//                 cust_id: custid
//             });
//         }
//     }, []);

//     const handleChange = (event) => {
//         //alert("form field change");
//         //let name = event.target.name;
//         ///let value = event.target.value;
//         // (event.target.name);
//         // (event.target.value);
//         //let customer_id = myparam.cust__id || myparam.customer_id;
//         setForm({ ...form, [event.target.name]: event.target.value });

//         //setForm({...form, cust_id : customer_id}) ;
//         //let valid = true;
//         //let validStateTemp = { ...validationState }
//         //let isSavartX = false;
//         if (event.target.name === "service_type" && event.target.value === "X") {
//             setQuantityDisable(true);
//             setForm({
//                 ...form,
//                 quantity: "1",
//                 service_type: "X"
//             });
//             //isSavartX = true;
//         } else if (event.target.name === "service_type" && event.target.value === "T") {
//             setQuantityDisable(true);
//             setForm({
//                 ...form,
//                 quantity: "1",
//                 service_type: "T"
//             });
//             //isSavartX = true;
//         } else if (event.target.name === "service_type" && (event.target.value === "A" || event.target.value === "R")) {
//             setQuantityDisable(false);
//             setDateDisable(false);
//         }
//         if ((event.target.name === "service_type" && event.target.value === "L") || (event.target.name === "service_type" && event.target.value === "U") || (event.target.name === "service_type" && event.target.value === "LX3")) {
//             let type;
//             if (event.target.value === "LX3") {
//                 type = "X3";
//             } else {
//                 type = event.target.value
//             }
//             http.get(`/getLateRenewalData?cust_id=${cust_id}&service_type=${type}`, form).then(res => {
//                 // (res);
//                 if (res.data.statusCode === 1) {
//                     toast.error(res.data.error + " Please Choose Different Service Type OR Contact Your CDT");
//                     setForm({
//                         ...form,
//                         service_type: ""
//                     });
//                     setDateDisable(false);
//                 }
//                 let stype;
//                 if (event.target.value === 'L') {
//                     stype = "L";
//                 }
//                 else if (event.target.value === 'U') {
//                     stype = "U";
//                 } else if (event.target.value === 'LX3') {
//                     stype = "LX3";
//                 }
//                 if (res.data.statusCode === 0) {
//                     // (res.data.Data);
//                     setForm({
//                         ...form,
//                         service_type: stype,
//                         date: res.data.Data,
//                         quantity: "1"
//                     });
//                     setDateDisable(true);
//                     setQuantityDisable(true);
//                     // toast.success(res.data.Data);
//                 }
//             }).catch(err => {
//                 // (err);
//             });

//         }
//         // else if (event.target.name === "service_type" && event.target.value !== "L") {
//         //     setForm({
//         //         ...form,
//         //         service_type: ""
//         //     });
//         //     setDateDisable(false);
//         // }
//     }

//     const [baseImage, setBaseImage] = useState("");

//     // const handleFileChange = async (event) => {
//     //     //alert("file received");
//     //     const file = event.target.files[0];
//     //     setBaseImage(file);

//     //     const base64 = await convertBase64(file);

//     //     //   setBaseImage(base64);
//     //     setForm({ ...form, proof: event.target.files[0] });
//     // }

//     const [image, setImage] = useState([]);

//     let data = new FormData();
//     (image + ' ' + 'this is image pathname')
//     data.append('image', image);

//     (image);

//     const handleFileChange=(event)=>{
//         // setImage(event.target.files[0]);
//         // setForm({ ...form, proof:URL.createObjectURL(event.target.files[0])});

//         let reader = new FileReader()
//         reader.readAsDataURL(event.target.files[0])

//         reader.onload = () => {
//          setForm({ ...form,
//             proof:reader.result
//          });
//        }
//     }

//     const convertBase64 = (file) => {
//         return new Promise((resolve, reject) => {
//             const fileReader = new FileReader();
//             fileReader.readAsDataURL(file);
//             fileReader.onload = () => {
//                 resolve(fileReader.result);
//             };
//             fileReader.onerror = (error) => {
//                 reject(error);
//             };
//         });
//     };

//     // const imgBase = {
//     //     file: baseImage,
//     //   };

//     // const postData={
//     //     cust_id:cust_id,
//     //     firstname:firstname,
//     //     lastname:lastname,
//     //     state:state,
//     //     payment_id:payment_id,
//     //     service_type:service_type,
//     //     quantity:quantity,
//     //     amount:amount,
//     //     date:date,
//     //     proof:proof
//     // }
//     // (postData);

//     const handleSubmit = (event) => {
//         //let customer_id = myparam.cust__id || myparam.customer_id;
//         //setForm({...form, cust_id:customer_id});

//         if (showfields === true) {
//             if (firstname === "" || lastname === "" || state === "" || payment_id === "" || service_type === "" || quantity === "" || amount === "" || date === "" || proof === "") {
//                 toast.error("Please fill all the fields");
//             }
//             else {
//                 http.post("/addSubscription", form).then(res => {

//                     if (res.data.statusCode === 1) {
//                         toast.error(res.data.error);
//                     }
//                     if (res.data.statusCode === 0) {
//                         toast.success(res.data.Data);
//                         if (myparam.cust__id) {
//                             history.push({
//                                 pathname: prospectPath, state: { "tab": "Overview" }
//                             });
//                         } else if (myparam.customer_id) {
//                             history.push({
//                                 pathname: investmentPath, state: { "tab": "Overview" }
//                             });
//                         }
//                     }
//                 }).catch(err => {
//                     (err);
//                 });
//             }
//         } else if (showfields === false) {
//             if (payment_id === "" || service_type === "" || quantity === "" || amount === "" || date === "" || proof === "") {
//                 alert('sf');
//                 toast.error("Please fill all the fields");
//             }
//             else {
//                 http.post("/addSubscription", form).then(res => {
//                    (res,'res');
//                     if (res.data.statusCode === 1) {
//                         toast.error(res.data.error);
//                     }
//                     if (res.data.statusCode === 0) {
//                         toast.success(res.data.Data);
//                         if (myparam.cust__id) {
//                             history.push({
//                                 pathname: prospectPath, state: { "tab": "Overview" }
//                             });
//                         } else if (myparam.customer_id) {
//                             history.push({
//                                 pathname: investmentPath, state: { "tab": "Overview" }
//                             });
//                         }
//                     }
//                 }).catch(err => {
//                     (err);
//                 });
//             }
//         }
//         //alert("submitted");
//         // else{
//         // }
//     }

//     const [showsSatesList, setShowStateList] = useState([]);
//     //(showsSatesList);
//     useEffect(() => {
//         http.get("/statesList").then(res => {
//             //(res);
//             //(res.data.Data);
//             setShowStateList(res.data.Data);
//         }).catch(err => {
//             (err);
//         });
//     }, []);
//     const [showfields, setShowfields] = useState(false);

//     // useEffect(()=>{
//     //     let cid = cust_id;
//     //     http.get(`/customerPersonalProfileStatus?cust_id=${cid}`).then(res=>{
//     //         //(res);
//     //         (res.data.Data);
//     //         if(res.data.Data === "C"){
//     //             setShowfields(false);
//     //         }
//     //         else if(res.data.Data === "P"){
//     //             setShowfields(true);
//     //         }
//     //         //setShowStateList(res.data.Data);
//     //     }).catch(err=>{
//     //         (err);
//     //     });
//     // },[]);

//     return (

//         <Grid container component="main" className={"pb30"}>

//             <Grid item xs={12} sm={5} md={5} >
//                 <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoProspectDetails}>Back</Button>
//             </Grid>
//             <Grid item xs={12} sm={5} md={5} className="mt30">
//                 <Typography color="textPrimary" variant="h5" >Add Payment</Typography>
//             </Grid>
//             <Grid container style={{ marginTop: 30 }}>
//                 {/* {
//                     columns.map(question => {
//                         return ( */}
//                 <Grid container className={classes.paper}>
//                     {/* <Grid item xs={12} sm={2} md={2} className={"formLable"}>
//                         <InputLabel className={classes.lableColor} id={question.label} style={{ paddingTop: "5px" }}>{question.label}
//                                         {question.imp && <span style={{color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem'}}>*</span>}
//                                     </InputLabel>
//                     </Grid> */}

//                     {/* <Grid item lg={6} md={6} sm={6} xs={12}>{question.filedType === "select" ?  }>

//                                 </Grid> */}
//                     {/* value={formObject[question.value] } name={question.value} onChange={handleChange} disabled={question.isDisable && quantityDisable} */}
//                     {/*
//                                 <Grid item lg={6} md={6} sm={6} xs={12}>
//                                 {question.filedType === "text" ?
//                                     <TextField label="Enter" variant="outlined" value={question.value} name={question.value} onChange={handleChange} style={{ width: "300px" }} /> :

//                                     question.filedType === "number"?
//                                     <TextField label="Enter" variant="outlined" value={question.value}  disabled={question.isDisable && quantityDisable} name={question.value} onChange={handleChange} style={{ width: "300px" }} type="number"/> :

//                                     question.filedType === "file" ?
//                                 <>
//                                     <input
//                                                 ref={fileInputRef}
//                                                 onChange={handleFileChange}
//                                                 type="file"
//                                                 style={{ display: "none" }}
//                                                 multiple={false}
//                                                 accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
//                                             />
//                                             <Button startIcon={<AddCircleOutlineIcon />} variant="outlined" className={classes.reviewButton} color="primary">Choose File</Button>
//                                             <span className="fileLable">{lookupFile && lookupFile.name ? lookupFile.name : "No file chosen"}</span>
//                                             </>
//                                             :
//                                             question.filedType === "dropDown" ?
//                                                         <FormControl  variant="outlined" className={classes.formControl}>
//                                                          <InputLabel id="state">State</InputLabel>
//                                                             <Select
//                                                                 labelId="state"
//                                                                 id="state"
//                                                                 value={question.value}
//                                                                 name={question.value}
//                                                                 onChange={handleChange}
//                                                                 >
//                                                                 {showsSatesList.map(item =>
//                                                                     <MenuItem value={item}>{item}</MenuItem>
//                                                                 )}

//                                                             </Select>
//                                                         </FormControl>
//                                                         :
//                                                         (question.filedType === "date") ? <TextField
//                                                             id="datePickerId"
//                                                             label="Select Date"
//                                                             type="date"
//                                                             defaultValue="07:30"
//                                                             variant="outlined"
//                                                             InputLabelProps={{
//                                                                 shrink: true,
//                                                             }}
//                                                             format="dd-mm-yyy"
//                                                             value={question.value}
//                                                             onChange={handleChange}
//                                                             InputProps={{inputProps: { min: getToday()} }}
//                                                             name={question.value}
//                                                         />
//                                             :
//                                             question.filedType === "radio" ?
//                                         <><RadioGroup row aria-label="position" name={question.value} defaultValue="A" value={question.value ? question.value : "A"} onChange={handleChange}>
//                                             {
//                                                 question.options.map(option => {
//                                                     return (
//                                                         <FormControlLabel
//                                                             control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={option.value} />}
//                                                             label={option.label}
//                                                             labelPlacement="end"
//                                                         />
//                                                     )
//                                                 })

//                                             }
//                                         </RadioGroup>
//                                         </>

//                                     : ""
//                                 }
//                                 </Grid> */}
//                     <Grid item lg={6} md={6} sm={6} xs={12}>
//                         {showfields ?
//                             <>
//                                 <Grid item lg={6} md={6} sm={6} xs={12}
//                                     style={{ marginBottom: '15px' }}

//                                 >
//                                     <InputLabel
//                                         style={{ marginBottom: '15px' }}
//                                     >First Name <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                                     <TextField label="Enter" variant="outlined" value={firstname} name="firstname" onChange={handleChange} style={{ width: "300px" }} />
//                                 </Grid>

//                                 <Grid item lg={6} md={6} sm={6} xs={12}
//                                     style={{ marginBottom: '15px' }}

//                                 >
//                                     <InputLabel
//                                         style={{ marginBottom: '15px' }}

//                                     >Last Name <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                                     <TextField label="Enter" variant="outlined" value={lastname} name="lastname" onChange={handleChange} style={{ width: "300px" }} />
//                                 </Grid>

//                                 <Grid item lg={6} md={6} sm={6} xs={12}
//                                     id='firstselect'
//                                     style={{ marginBottom: '15px' }}

//                                 >
//                                     <InputLabel
//                                         style={{ marginBottom: '15px' }}

//                                     >State <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                                     <FormControl variant="outlined" className={classes.formControl}>
//                                         {/* <InputLabel id="state">State</InputLabel> */}
//                                         <Select
//                                             //labelId="state"
//                                             id="service_type"
//                                             displayEmpty
//                                             value={state}
//                                             name="state"
//                                             onChange={handleChange}
//                                             style={{ width: "300px" }}
//                                         >
//                                             <MenuItem value="">Select</MenuItem>
//                                             {showsSatesList.map(item =>
//                                                 <MenuItem value={item}>{item}</MenuItem>
//                                             )}
//                                         </Select>
//                                     </FormControl>
//                                 </Grid>
//                             </>
//                             : ""}

//                         <Grid item lg={6} md={6} sm={6} xs={12}
//                             id='firstselect'
//                             style={{ marginBottom: '15px' }}

//                         >
//                             <InputLabel
//                                 style={{ marginBottom: '15px' }}

//                             >Service type <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                             <FormControl variant="outlined" className={classes.formControl}>
//                                 {/* <InputLabel id="state">State</InputLabel> */}
//                                 <Select
//                                     //labelId="state"
//                                     displayEmpty
//                                     id="service_type"
//                                     value={service_type}
//                                     name="service_type"
//                                     onChange={handleChange}
//                                     style={{ width: "300px" }}
//                                 >
//                                     <MenuItem value="">Select</MenuItem>
//                                     <MenuItem value="X">Savart X</MenuItem>
//                                     <MenuItem value="A">Investment Request</MenuItem>
//                                     <MenuItem value="R">Investment Review</MenuItem>
//                                     <MenuItem value="L">Early Renewal SavartX</MenuItem>
//                                     <MenuItem value="T">SavartX3</MenuItem>
//                                     <MenuItem value="U">Upgrade</MenuItem>
//                                     <MenuItem value="LX3">Early Renewal SavartX3</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </Grid>

//                         <Grid item lg={6} md={6} sm={6} xs={12}
//                             style={{ marginBottom: '15px' }}

//                         >
//                             <InputLabel
//                                 style={{ marginBottom: '15px' }}

//                             >Quantity <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                             <TextField label="Enter" variant="outlined" value={quantity} name="quantity" onChange={handleChange} style={{ width: "300px" }} type="number" disabled={quantityDisable ? "disabled" : ""} />
//                         </Grid>

//                         <Grid item lg={6} md={6} sm={6} xs={12}
//                             style={{ marginBottom: '15px' }}

//                         >
//                             <InputLabel
//                                 style={{ marginBottom: '15px' }}

//                             >Subscription Amount <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                             <TextField label="Enter" variant="outlined" value={amount} name="amount" onChange={handleChange} style={{ width: "300px" }} type="number" />
//                         </Grid>

//                         <Grid item lg={6} md={6} sm={6} xs={12}
//                             style={{ marginBottom: '15px' }}

//                         >
//                             <InputLabel
//                                 style={{ marginBottom: '15px' }}

//                             >Subscription Date <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                             <TextField variant="outlined" disabled={dateDisable ? true : false} value={date} name="date" onChange={handleChange} style={{ width: "300px" }} type="date" />
//                         </Grid>

//                         <Grid item lg={6} md={6} sm={6} xs={12}
//                             style={{ marginBottom: '15px' }}

//                         >
//                             <InputLabel
//                                 style={{ marginBottom: '15px' }}

//                             >Payment Id <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                             <TextField label="Enter" variant="outlined" value={payment_id} name="payment_id" onChange={handleChange} style={{ width: "300px" }} type="text" />
//                         </Grid>

//                         <Grid item lg={6} md={6} sm={6} xs={12}
//                             style={{ marginBottom: '15px' }}

//                         >
//                             <InputLabel
//                                 style={{ marginBottom: '15px' }}

//                             >Subscription Proof <span style={{ color: 'red' }}>&#42;</span></InputLabel>
//                             <input
//                                 id='file'
//                                 type="file"
//                                 onChange={(e) => {
//                                     handleFileChange(e);
//                                 }}
//                                 // onChange={e => setImage(e.target.value)}
//                                 // style={{ display: "none" }}
//                                 multiple={false}
//                                 accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
//                             />
//                              {/* <img src={proof} /> */}
//                         </Grid>
//                     </Grid>
//                 </Grid>
//                 {/* )
//                     }
//                     )
//                 }*/}
//             </Grid>
//             <Grid container className={classes.submitButton}>
//                 <Grid item xs={3} sm={2} md={2}
//                     style={{
//                         display: 'flex',
//                         justifyContent: 'center'
//                     }}
//                 >
//                     <Button variant="contained" color="primary" onClick={handleSubmit}>Add payment</Button>
//                 </Grid>
//             </Grid>
//         </Grid>
//     )

// }

// export default AddPayment;
